import { AirChfarOffer } from "@b2bportal/air-chfar-api";

export interface AirChangeForAnyReasonContext {
  chfarQuoteId?: string;
  chfarOffers?: AirChfarOffer[];
  selectedOffer?: AirChfarOffer;
}

export const getAirChfarInitialContext = (): AirChangeForAnyReasonContext => ({
  chfarQuoteId: undefined,
  chfarOffers: undefined,
  selectedOffer: undefined,
});
